import { toast, ToastOptions } from "react-toastify";

// Using ToastPosition to specify position types
import { ToastPosition } from "react-toastify";

/**
 * Show a toast notification.
 * @param message - The message to display.
 * @param isSuccess - If true, show a success notification; otherwise, show an error notification.
 * @param position - The position where the toast will appear.
 */
const showToast = (
  message: string,
  isSuccess: boolean,
  position: ToastPosition = "top-right"
) => {
  const options: ToastOptions = {
    position,
    autoClose: 3000,
  };

  if (isSuccess) {
    toast.success(message, options);
  } else {
    toast.error(message, options);
  }
};

export default showToast;
